import { Injectable, Inject, forwardRef } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { IApiresponse } from "src/app/_models/common/request-response/apiresponse";
import { IApiRequest } from "src/app/_models/common/request-response/api-request";
import { setHeader } from "src/app/_helpers/setRequestHeader";
import { ClaimsHeaderService } from "src/app/shared/claimsHeader/claims-header.service";
import { ISetupOrganisationDetailsResponse, UpdateSetupOrganisationDetailsRequest } from "src/app/_models/setup-organisation/setup-organisation";

@Injectable({
    providedIn: "root",
})
export class SetupOrganisationService {
    httpHeaders: HttpHeaders;
    constructor(
        private http: HttpClient,
        private claimsHeaderService: ClaimsHeaderService
    ) { }

    GetSetupOrganisationDetails(organisationId: number): Observable<IApiresponse<ISetupOrganisationDetailsResponse>> {
        let params = new HttpParams();
        params = params.append("organisationId", organisationId.toString());
        return this.http.get<IApiresponse<ISetupOrganisationDetailsResponse>>(`${environment.billingApiUrl}GetSetupOrganisationDetails`, { params: params, headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
    }

    UpdateSetupOrganisationDetails(requestInfo: IApiRequest<UpdateSetupOrganisationDetailsRequest>): Observable<IApiresponse<any>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<any>>(`${environment.billingApiUrl}UpdateSetupOrganisationDetails`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
    }
}


